export function isBlank(str: string) {
    return (!str || /^\s*$/.test(str));
}

export function isEmpty(str: string) {
    return (!str || str.length === 0);
}

